import { useQuery } from '@tanstack/react-query';
import { SECURE_MESSAGES_KEY } from '../../utils/constants/queryKeys';
import { getUnreadSecureMessageCount } from '../services/fn-api/SecureMessages';

export const useGetUnreadSecureMessageCount = () => {
  return useQuery({
    queryKey: [SECURE_MESSAGES_KEY],
    queryFn: () => getUnreadSecureMessageCount(),
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes.
    refetchIntervalInBackground: false, // Disable fetching while window isn't focused
    refetchOnWindowFocus: 'always', // Refetch as soon as the user re-focuses the page
  });
};
